export default "__VITE_ASSET__DfGHfshh__"